@if (loaded) {
  <p-select
    [filter]="true"
    [options]="teamList"
    [disabled]="disabled()"
    [ngModel]="team"
    (ngModelChange)="team = $event; onTeamChange($event)"
    placeholder="Team"
    appendTo="body"
    dataKey="id"
    [showClear]="true"
  >
  </p-select>
}
